/**
 * Application constants
 */

// UI Constants
export const UI_CONSTANTS = {
  EMPLOYEE_ID_LENGTH: 4,
  ANIMATION_DELAY: 100,
  PRINT_DIALOG_DELAY: 1000,
  QR_CODE_SIZE: 110,
  QR_CODE_SIZE_PRINT: 100,
  QR_CODE_LEVEL: 'M',
  
  // Pagination
  DEFAULT_ITEMS_PER_PAGE: 10,
  ITEMS_PER_PAGE_OPTIONS: [5, 10, 25, 50, 100],
  MAX_VISIBLE_PAGES: 5,
  
  // Input limits
  MAX_INPUT_LENGTH: 1000,
  MAX_SEARCH_LENGTH: 100,
  MAX_USERNAME_LENGTH: 50,
  MIN_USERNAME_LENGTH: 2,
  MAX_PASSWORD_LENGTH: 128,
};

// Status Constants
export const DELIVERY_STATUS = {
  DELIVERED: 'delivered',
  COLLECTED: 'collected',
  RETURNED: 'returned',
  NOT_DELIVERED: 'not-delivered',
  NOT_COLLECTED: 'not-collected',
};

// Goodie Types
export const GOODIE_TYPES = {
  ID_CARD: 'ID Card',
  SHOE: 'Shoe',
  KURTA: 'Kurta',
  LAPEL_PIN: 'Lapel Pin',
};

// Size Constants
export const CLOTHING_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
export const SHOE_SIZE_RANGE = { MIN: 5, MAX: 15 };

// Role Constants
export const USER_ROLES = {
  CREW: 'crew',
  REGULAR: 'regular',
  ADMIN: 'admin',
};

// Route Constants
export const ROUTES = {
  HOME: '/',
  LOGIN: '/',
  START: '/start',
  ID_CARD: '/idcard',
  GOODIES: '/goodies',
  DASHBOARD: '/dashboard',
};

// Storage Keys (for backward compatibility)
export const LEGACY_STORAGE_KEYS = {
  IS_AUTHENTICATED: 'isAuthenticated',
  CURRENT_USER: 'currentUser',
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Unable to connect to server. Please check if the backend is running.',
  TIMEOUT_ERROR: 'Request timed out. Please check your connection and try again.',
  AUTH_REQUIRED: 'Please log in to continue.',
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
  EMPLOYEE_NOT_FOUND: 'Employee not found',
  INVALID_CREDENTIALS: 'Invalid username or password',
  VALIDATION_REQUIRED: 'This field is required',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Successfully logged in',
  LOGOUT_SUCCESS: 'Successfully logged out',
  DATA_UPDATED: 'Data updated successfully',
  GOODIES_UPDATED: 'Goodies status updated successfully',
};

// Animation Timings
export const ANIMATIONS = {
  FADE_IN_DURATION: 300,
  SLIDE_DURATION: 400,
  BUTTON_HOVER_DURATION: 300,
  MODAL_TRANSITION: 250,
};

// Breakpoints for responsive design
export const BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 1024,
  LARGE_DESKTOP: 1440,
};

// Theme Colors (for consistency)
export const THEME_COLORS = {
  PRIMARY: '#4169E1',
  SECONDARY: '#00CED1',
  SUCCESS: '#28a745',
  ERROR: '#ff6b6b',
  WARNING: '#ffc107',
  INFO: '#17a2b8',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
};

// API Configuration
export const API_CONFIG = {
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 2,
  RETRY_DELAY: 1000,
};

// Development flags
export const DEV_FLAGS = {
  SHOW_ERROR_DETAILS: process.env.NODE_ENV === 'development',
  ENABLE_LOGGING: process.env.NODE_ENV === 'development',
  MOCK_API: process.env.REACT_APP_MOCK_API === 'true',
};
